export default {
  getUploads: state => state.uploads,
  getUploadIsUploading: state => state.isUploading,
  getActiveUploads: state => state.uploads.filter(x => x.status === 'uploading').length,
  getSuccessUploads: state => state.uploads.filter(x => x.status === 'success').length,
  getSuccessAndReencodedUploads: state => state.uploads.filter(x => x.status === 'success').length + state.uploads.filter(x => x.status === 'reencoded@success').length,
  getFailedUploads: state => state.uploads.filter(x => x.status === 'failed').length,
}
